import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { HeroSection } from '../components/HeroSection';
import { StoryHook } from '../components/StoryHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-stone-950 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-237">
      <UrgencyBanner data-id="element-238" />
      <HeroSection data-id="element-239" />
      <StoryHook data-id="element-240" />
      <ProblemSection data-id="element-241" />
      <FailedSolutions data-id="element-242" />
      <MechanismSection data-id="element-243" />
      <TestimonialsSection data-id="element-244" />
      <WhatYouGet data-id="element-245" />
      <WhoIsItFor data-id="element-246" />
      <HowItWorks data-id="element-247" />
      <ProofSection data-id="element-248" />
      <GuaranteeSection data-id="element-249" />
      <FAQSection data-id="element-250" />
      <PricingSection data-id="element-251" />
      <Footer data-id="element-252" />
    </main>;
}